export default __webpack_public_path__ + "static/media/r6x_logo.40ab1a54.png";